import { apiClient } from '@/services/apiClient';
import { useMutation } from '@tanstack/react-query';
import { Routes } from './routes';
import type { ProviderEnum } from '@/types/common';

export const useRemoveCard = () => {
  return useMutation({
    mutationFn: async ({
      pspCardIdentifier,
      paymentProvider,
    }: {
      pspCardIdentifier: string;
      paymentProvider: ProviderEnum;
    }) => {
      const response = await apiClient.post(`${Routes.REMOVE_CARD}`, { pspCardIdentifier, paymentProvider });
      return response;
    },
  });
};
